/** Catálogo simplificado de actividades (SAT / referencia en formularios). */
export const ACTIVIDADES_SAT = [
    { codigo: '4641110', nombre: 'Comercio al por menor de artículos de papelería' },
    { codigo: '4641120', nombre: 'Comercio al por menor de libros' },
    { codigo: '5411100', nombre: 'Servicios legales (Notarías / Corredurías)' },
    { codigo: '5311101', nombre: 'Arrendamiento de vivienda' },
    { codigo: '5312100', nombre: 'Inmobiliarias y corredores de bienes raíces' },
    { codigo: '9999999', nombre: 'OTRA ACTIVIDAD (ESPECIFICAR EN XML)' },
];
